import TextInput from '@/components/common/TextInput';
import { useTranslation } from 'react-i18next';
import { TrackEditViewTemplateProps } from '../TrackEditViewTemplate';
import { BaseFormGroupProps } from './types';

type Props = Pick<
  TrackEditViewTemplateProps,
  | 'handleInput'
  | 'baseMixedTrack'
  | 'trackData'
  | 'fieldHasErrors'
  | 'isMultipleTrack'
  | 'findErrorMessage'
  | 'areNewMultipleTracks'
> &
  BaseFormGroupProps;

export default function TrackTitleFormGroup({
  trackData,
  baseMixedTrack,
  isMultipleTrack,
  readonly,
  disabled,
  areNewMultipleTracks,
  handleInput,
  fieldHasErrors,
  findErrorMessage,
}: Props) {
  const { t } = useTranslation();

  return (
    <div className="form-group">
      <TextInput
        labelClassName="col-sm-3 form-label"
        labelTitle={t('track.trackTitle')}
        handleInput={(e) => {
          handleInput('title', e.target.value);
        }}
        handleUndo={(value) => {
          handleInput('title', value);
        }}
        id="title"
        type="text"
        value={
          !isMultipleTrack
            ? trackData.title
            : (baseMixedTrack?.title?.value as string)
        }
        inputClassname="form-control"
        className="col-sm-6"
        hasErrors={!isMultipleTrack ? fieldHasErrors('Title') : false}
        errorMessage={!isMultipleTrack ? findErrorMessage('Title') : ''}
        isReadOnly={readonly}
        isDisabled={disabled}
        autoFocus={true}
        isRequired={!isMultipleTrack}
        fieldValidationKey="trackEditMode.Title"
        mixedValue={baseMixedTrack?.title}
        showChangeIndicator={!areNewMultipleTracks}
      />
    </div>
  );
}
